import { lazy } from "react";
import Loadable from "app/components/Loadable";


const LeaveAppLandingPage = Loadable(
  lazy(() => import("./LeaveApplicationLandingPage"))
);
const LeaveApplicationAdd = Loadable(
  lazy(() => import("./LeaveApplicationAdd"))
);

const LeaveApplicationRoutes = [
{ path: "/ems/leave/application", element: <LeaveAppLandingPage /> },
{
  path: "/ems/leave/application/:mode/:id",
  element: <LeaveApplicationAdd />
}];


export default LeaveApplicationRoutes;